module.exports={author:"Imani Elizabeth Jackson",date:"02/09/2021",publishDate:"12/24/2020",highlighted:!1,tags:"",title:"And went to plant"};